<template>
    <div style="width: 100%">
        <div style="width: 100%;height: 30px;background-color: #e3e3e3;display: flex;font-size: 13px">
            <div style="margin: auto 0;color: #595a5a;padding-left: 20px"><span>当前位置：</span></div>
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: auto 0;font-size: 13px">
                <el-breadcrumb-item v-for="(item,index) in $route.meta.position" :key="index">
                    {{item}}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div style="background-color: white;padding: 10px 10px 10px 10px">
            <el-form ref="form" :model="form" label-width="80px">
                <!--第一行搜索-->
                <el-row>
                    <el-col :span="8">
                        <el-form-item label="供应商名称: " label-width="120px">
                            <el-input v-model="form.name" style="width: 100%;border: 0px;"  placeholder="请输入供应商名称" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="联系人：" label-width="120px">
                            <el-input v-model="form.name" style="width: 100%;border: 0px;" placeholder="请输入联系人" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item label="联系电话：" label-width="120px">
                            <el-input v-model="form.name" style="width: 100%;border: 0px;" placeholder="请输入联系电话" size="small"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row style="text-align: right;">
                    <el-button type="info" size="small">
                        重置
                    </el-button>
                    <el-button type="primary" size="small">
                        搜索
                    </el-button>
                </el-row>
            </el-form>
        </div>
        <!--按钮组-->
        <div style="margin-top: 20px">
            <el-row>
                <el-button type="warning" @click="diaLog.addDialogFormVisible=true" size="small">添加供应商</el-button>
            </el-row>
        </div>
        <!--table-->
        <div style="margin-top: 20px;margin-bottom:20px;background-color: white;padding: 10px 20px 10px 20px">
            <div style="background-color: white">
                <el-table
                        :data="tableData"
                        border
                        style="width: 100%"
                        :header-cell-style="{background:'#eef1f6',color:'#595a5a'}">
                    <el-table-column
                            prop="gysName"
                            label="供应商名称">
                    </el-table-column>
                    <el-table-column
                            prop="gysType"
                            label="供应商类型">
                    </el-table-column>
                    <el-table-column
                            prop="remark"
                            label="备注">
                    </el-table-column>
                    <el-table-column
                            prop="lxr"
                            label="联系人">
                        <template slot-scope="scope">
                            <span>asdasdas</span><br>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="lxfs"
                            label="联系方式">
                    </el-table-column>
                    <el-table-column
                            prop="address"
                            label="地址">
                    </el-table-column>
                    <el-table-column
                            prop="time"
                            label="添加时间">
                    </el-table-column>
                    <el-table-column prop="handel" label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="edit(scope.row)">编辑</el-button>
                            </br>
                            <el-button type="text" size="mini" style="margin-top: 2px" @click="bhSh">删除
                            </el-button>
                            </br>
                        </template>
                    </el-table-column>
                </el-table>
                <template>
                    <div class="block" style="text-align: right">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page.sync="page.currentPage1"
                                :page-size="100"
                                layout="total, prev, pager, next"
                                :total="1000">
                        </el-pagination>
                    </div>
                </template>
            </div>

        </div>
        <!-- 添加仓库弹出框 -->
        <el-dialog :close-on-click-modal="false"   class="titleCor"  title="新增供应商" :visible.sync="diaLog.addDialogFormVisible" :destroy-on-close=true
                  @close="closeDia">
            <el-form :model="addForm" :rules="rules"  ref="addForm" style="width: 100%;">
                <el-form-item prop="gysType"  label="供应商类型: " :label-width="addFormLabelWidth">
                    <el-radio v-model="addForm.gysType" label="1">1688供应商</el-radio>
                    <el-radio v-model="addForm.gysType" label="2">其他供应商</el-radio>
                </el-form-item>
                <el-form-item prop="gysName" label="供应商名称: " :label-width="addFormLabelWidth">
                    <el-input v-model="addForm.gysName" autocomplete="off" style="width: 90%;" size="small"></el-input>
                </el-form-item>
                <el-form-item label="联系人: " :label-width="addFormLabelWidth">
                    <el-input v-model="addForm.lxr" autocomplete="off" style="width: 90%;" size="small"></el-input>
                </el-form-item>
                <el-form-item label="手机号码: " :label-width="addFormLabelWidth">
                    <el-input v-model="addForm.lxfs" autocomplete="off" style="width: 90%;" size="small"></el-input>
                </el-form-item>
                <el-form-item label="电话号码: " :label-width="addFormLabelWidth">
                    <el-input v-model="addForm.lxfs" autocomplete="off" style="width: 90%;" size="small"></el-input>
                </el-form-item>
                <el-form-item label="QQ: " :label-width="addFormLabelWidth">
                    <el-input v-model="addForm.lxfs" autocomplete="off" style="width: 90%;" size="small"></el-input>
                </el-form-item>
                <el-form-item label="Email: " :label-width="addFormLabelWidth">
                    <el-input v-model="addForm.lxfs" autocomplete="off" style="width: 90%;" size="small"></el-input>
                </el-form-item>
                <el-form-item label="网址: " :label-width="addFormLabelWidth">
                    <el-input v-model="addForm.lxfs" autocomplete="off" style="width: 90%;" size="small"></el-input>
                </el-form-item>
                <el-form-item label="地址: " :label-width="addFormLabelWidth">
                    <el-input v-model="addForm.address" autocomplete="off" style="width: 90%;" size="small"></el-input>
                </el-form-item>
                <el-form-item label="备注: " :label-width="addFormLabelWidth">
                    <el-input v-model="addForm.remark" autocomplete="off" style="width: 90%;" size="small"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="diaLog.addDialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="diaLog.addDialogFormVisible = false">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 编辑仓库弹出框 -->
        <el-dialog :close-on-click-modal="false"    class="titleCor" title="编辑供应商" :visible.sync="diaLog.editDialogFormVisible" :destroy-on-close=true
                   @close="closeDia">
            <el-form :model="editForm" ref="editForm" style="width: 100%;">
                <el-form-item prop="gysName" label="供应商名称: " :label-width="addFormLabelWidth">
                    <el-input v-model="editForm.gysName" autocomplete="off" style="width: 90%;" size="small"></el-input>
                </el-form-item>
                <el-form-item label="供应商类型: " :label-width="addFormLabelWidth">
                    <el-input v-model="editForm.gysType" autocomplete="off" style="width: 90%;" size="small"></el-input>
                </el-form-item>
                <el-form-item label="备注: " :label-width="addFormLabelWidth">
                    <el-input v-model="editForm.remark" autocomplete="off" style="width: 90%;" size="small"></el-input>
                </el-form-item>
                <el-form-item label="联系人: " :label-width="addFormLabelWidth">
                    <el-input v-model="editForm.lxr" autocomplete="off" style="width: 90%;" size="small"></el-input>
                </el-form-item>
                <el-form-item label="联系方式: " :label-width="addFormLabelWidth">
                    <el-input v-model="editForm.lxfs" autocomplete="off" style="width: 90%;" size="small"></el-input>
                </el-form-item>
                <el-form-item label="地址: " :label-width="addFormLabelWidth">
                    <el-input v-model="editForm.address" autocomplete="off" style="width: 90%;" size="small"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="diaLog.editDialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="diaLog.editDialogFormVisible = false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                addFormLabelWidth: '100px',
                //搜索
                form: {
                    name: '',
                    ydh: '',
                    sort: ''
                },
                //添加
                addForm: {
                    gysName: '',
                    gysType: '1',
                    remark: '',
                    lxr: '',
                    lxfs: '',
                    address: '',
                },
                //编辑
                editForm: {
                    gysName: '',
                    gysType: '',
                    remark: '',
                    lxr: '',
                    lxfs: '',
                    address: '',
                },
                // 分页
                page: {
                    currentPage1: 5,
                },
                //弹窗
                diaLog: {
                    addDialogFormVisible: false,
                    editDialogFormVisible: false
                },
                //表格
                tableData: [{
                    gysName: '肃宁县翔锐渔具厂',
                    gysType: '1688供应商',
                    remark: '优质供应商',
                    lxr: '林',
                    lxfs: '1380000000',
                    address: '浙江省杭州市西湖区文三路',
                    time:'2020-06-04 12:09:02'
                }, {
                    gysName: '肃宁县翔锐渔具厂',
                    gysType: '1688供应商',
                    remark: '优质供应商',
                    lxr: '林',
                    lxfs: '1380000000',
                    address: '浙江省杭州市西湖区文三路',
                    time:'2020-06-04 12:09:02'
                }, {
                    gysName: '肃宁县翔锐渔具厂',
                    gysType: '1688供应商',
                    remark: '优质供应商',
                    lxr: '林',
                    lxfs: '1380000000',
                    address: '浙江省杭州市西湖区文三路',
                    time:'2020-06-04 12:09:02'
                }, {
                    gysName: '肃宁县翔锐渔具厂',
                    gysType: '1688供应商',
                    remark: '优质供应商',
                    lxr: '林',
                    lxfs: '1380000000',
                    address: '浙江省杭州市西湖区文三路',
                    time:'2020-06-04 12:09:02'
                }],
                rules: {
                    gysName: [
                        {required: true, message: '请输入供应商名称', trigger: 'blur'},
                    ],
                    gysType: [
                        {required: true, message: '请选择供应商类型', trigger: 'blur'},
                    ],

                }
            };
        },
        methods: {
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                console.log(`当前页: ${val}`);
            },
            add(index) {
                this.ddhtableData[index].dt.push({
                    ddh: ''
                });
            },
            deletei(index) {
                //获取每个输入框的值
                // alert(this.ddhtableData[0].dt[index].ddh)
                this.ddhtableData[0].dt.splice(index, 1)
            },
            //提交审核
            submitSh() {
                this.$confirm('此操作将提交审核, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '审核成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '审核失败'
                    });
                });
            },
            //提交审核
            bhSh() {
                this.$confirm('此操作将驳回审核, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$message({
                        type: 'success',
                        message: '驳回审核成功!'
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '驳回审核失败'
                    });
                });
            },
            //编辑
            edit(row){
                this.diaLog.editDialogFormVisible=true
                for (let key in this.editForm) {
                    this.editForm[key] = row[key];
                }
            },
            //dia关闭前清空数据
            closeDia() {
                for (let key in this.addForm) {
                    this.addForm[key] = "";
                }
            },
        }
    }
</script>

<style scoped>
    .in {
        width: 300px;
    }

    .head .el-dialog__header {
        background-color: #eef1f6;
    }

    .titleCor >>> .el-dialog__title{
        color: #8E8E8E;
    }
</style>
